<template>
    <div class="marketing-award g-clearfix" :style="backgroundStyle">
        <div v-if="loading" class="loading-mask">
            <span :class="{ loading: loading }"></span>
        </div>
        <WxOpenBrowserMask v-model="isShowMask" />
        <MarketingAwardLocation
            v-if="!disableLocate"
            v-show="showLocation"
            ref="awardLocation"
            :isInit="isInit"
            :isInitLocation.sync="isInitLocation"
            :isInitializedLocation.sync="isInitializedLocation"
            :distanceDescColor="distanceDescColor"
            :refreshBtnColor="refreshBtnColor"
            :distanceValid="distanceValid"
            :locationType="locationType"
            :coordinates="coordinates"
            :coordinatesName="coordinatesName"
            :userPosition.sync="userPosition"
            @track="trackClick"
        />
        <MarketingAwardButton
            :isLoading.sync="isLoading"
            :status="buttonStatus"
            :notReceivedBtnImg="notReceivedBtnImg"
            :notAvailableBtnImg="notAvailableBtnImg"
            :receivedBtnImg="receivedBtnImg"
            @action="buttonClick"
        />
        <NioDialog
            :visible="isShowReceiveAwardsDialog"
            :title="receiveAwardsDlgSetting.title"
            :content="receiveAwardsDlgSetting.desc"
            :confirmText="receiveAwardsDlgSetting.btnText"
            :cancelText="'关闭'"
            :cancelClass="'radius'"
            :confirmClass="'radius'"
            @confirm="handleClick(awardClickTypeEnum.jumpToAward)"
            @cancel="handleCloseDialog"
        >
            <template slot="content" class="receive-awards-dialog">
                <img
                    v-if="receiveAwardsDlgSetting.img"
                    :src="receiveAwardsDlgSetting.img"
                    class="receive-awards-dialog-img"
                    @error="handleImageError"
                />
                <div class="receive-awards-dialog-desc">
                    {{ receiveAwardsDlgSetting.desc }}
                </div>
            </template>
        </NioDialog>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { isWx } from '@/util/report/nioapp-event-report/utils';
  import { isInNioCNApp, redirectToViewBridge } from '@/util/platform/universal';
  import { pushHash } from '@/util/dmp/push-hash';
  import { NIO_SCHEMA, PAGE_MODE_MAP } from '@/config/enums';
  import NioDialog from '@/marketing_components/common/nio-dialog';
  import trackExposeMixin from '../../mixin/track-expose';
  import WxOpenBrowserMask from '../wx-open-browser-mask';
  import MarketingAwardButton from './award-button';
  import MarketingAwardLocation from './award-location';
  import {
      awardLocationStatus,
      awardIssueStatus,
      awardButtonStatus,
      awardClickTypeEnum,
  } from './helper';
  import loginMixin from "../../mixin/login"

  const mixin = {
      methods: {
          ...mapActions('marketing/', [
              'getAwardCompConfig',
              'getAwardCompAwardsDetail',
              'getAwardCompUserParticipation',
              'awardCompReceiveAwards',
              'rgeoDetail',
          ])
      },
      computed: {
          ...mapState('marketing/', [
              'campaignOption',
              'pageConfig',
              'userProfile'
          ])
      }
  };

  export default {
      components: {
          NioDialog,
          WxOpenBrowserMask,
          MarketingAwardButton,
          MarketingAwardLocation
      },
      mixins: [mixin, trackExposeMixin, loginMixin],
      props: {
          index: Number,
          rootMark: String,
          customStyle: {
              type: String,
              default: 'margin-top: 0; margin-bottom:0'
          },
          fixed: {
              type: Boolean,
              default: true
          },
          backgroundSetting: {
              type: Object,
              default: () => ({
                  backgroundType: 'color',
                  background: '#fff'
              })
          },
          notReceivedBtnImg: String,
          notAvailableBtnImg: String,
          receivedBtnImg: String,
          awardPageLink: String,
          notAvailableTip: String,
          channelCode: String,
          awardAliasPrimary: String,
          awardAliasSecondary: String,
          crowdConditionId: [String, Number],
          distanceDescColor: String,
          refreshBtnColor: String,
          distanceValid: [String, Number],
          locationType: Array,
          coordinates: String,
          coordinatesName: String,
          trackSelectAction: Function,
          disableLocate: {
              type: Boolean,
              default: false
          },
          formMode: {
              type: String,
              value: 'leads'
          },
          componentId: [String, Number],
          positionRank: [String, Number],
          trackName: String,
          lpConfig: Object
      },
      data() {
          return {
              awardClickTypeEnum,
              // 状态
              isInit: false,
              isInitLocation: false,
              isInitializedLocation: false, // 是否初始化过地理授权
              isLoading: false,
              isShowMask: false,
              isShowReceiveAwardsDialog: false,
              // 组件配置
              awardCompConfig: {
                  appHomePage: '', // app首页
                  downloadMiddlePage: '', // 下载中间页
              },
              // 用户参与情况
              canParticipate: true, // 是否允许参与
              isParticipate: false, // 是否已参与
              // 用户位置信息
              userPosition: {
                  distance: undefined,
                  lat: undefined,
                  lng: undefined,
                  cityName: undefined
              },
              // 弹框
              receiveAwardsDlgSetting: {
                  title: '领取成功',
                  btnText: '查看奖励',
                  desc: '恭喜获得打卡奖励',
                  img: ''
              }
          };
      },
      computed: {
          loading() {
              return this.isLoading || this.isInit || this.isInitLocation;
          },
          backgroundStyle() {
              const { backgroundType, background } = this.backgroundSetting;
              if (backgroundType === 'img') {
                  return this.imgBgStyle(background);
              }
              if (backgroundType === 'color') {
                  return { background };
              }
              return {};
          },
          imgBgStyle() {
              return url => {
                  if (url) {
                      return {
                          background: `center / cover no-repeat url(${url})`
                      };
                  }
                  return { background: '#fff' };
              };
          },
          locationStatus() {
              const distance = this.userPosition.distance; // 当前距离
              const distanceValid = this.distanceValid; // 有效距离

              // 不校验
              if (this.disableLocate) {
                  return awardLocationStatus.FULFILLED;
              }
              // 未初始化
              if (!this.isInitializedLocation) {
                  return awardLocationStatus.UNINITIALIZED;
              }
              // 获取中
              if (this.isInitLocation) {
                  return awardLocationStatus.PENDING;
              }

              if (distance === undefined) {
                  return awardLocationStatus.REJECTED; // 无法获取位置信息
              } else if (distance > distanceValid) {
                  return awardLocationStatus.INVALID; // 大于有效距离
              } else {
                  return awardLocationStatus.FULFILLED; // 小于有效距离
              }
          },
          issueStatus() {
              if (!this.isLogin) {
                  return awardIssueStatus.PENDING; // 可领取
              }
              if (this.canParticipate) {
                  if (this.isParticipate) {
                      return awardIssueStatus.FULFILLED; // 已领取
                  }
                  return awardIssueStatus.PENDING; // 可领取
              }
              return awardIssueStatus.REJECTED; // 不可领取
          },
          buttonStatus() {
              const { locationStatus, issueStatus } = this;

              // 不可参与
              if (issueStatus === awardIssueStatus.REJECTED) {
                  return awardButtonStatus.REJECTED;
              }
              // 已参与
              if (issueStatus === awardIssueStatus.FULFILLED) {
                  return awardButtonStatus.FULFILLED;
              }

              // 可参与
              if (locationStatus === awardLocationStatus.UNINITIALIZED) {
                  return awardButtonStatus.PENDING;
              }
              if (locationStatus === awardLocationStatus.FULFILLED) {
                  return awardButtonStatus.PENDING;
              }
              if (locationStatus === awardLocationStatus.REJECTED) {
                  return awardButtonStatus.REJECTED;
              }
              if (locationStatus === awardLocationStatus.INVALID) {
                  return awardButtonStatus.REJECTED;
              }
              return awardButtonStatus.PENDING;
          },
          showLocation() {
              return ![
                  awardIssueStatus.REJECTED,
                  awardIssueStatus.FULFILLED
              ].includes(this.issueStatus);
          }
      },
      mounted() {
          this.init();
      },
      methods: {
          async init() {
              this.isInit = true;
              try {
                  await this.checkConfig(); // 页面配置
                  await this.checkUser(); // #1 登录信息
                  await this.getUserProfile(); // #2 用户信息 依赖#1
                  await this.checkParticipate(); // #3 人群条件 依赖#2
                  await this.checkAwardsDetail(); // #4 奖励详情和参与情况 依赖#2
              } catch (e) {
                  console.log('[init] error: ', e);
              } finally {
                  this.isInit = false;
              }
          },
          async checkConfig() {
              try {
                  const awardCompConfigDetail = await this.getAwardCompConfig();
                  if (awardCompConfigDetail) {
                      this.awardCompConfig = awardCompConfigDetail.data;
                  }
              } catch (e) {
                  console.log(e);
              }
          },
          async checkParticipate() {
              try {
                  const user_id = this.userProfile.user_id

                  if (!user_id) return

                  const participateInfo = await this.getAwardCompUserParticipation(
                      {
                          user_id,
                          crowd_id: this.crowdConditionId,
                          headers: { authorization: this.token }
                      }
                  );

                  if (participateInfo.result_code !== 'success'  || !participateInfo.data) {
                    throw participateInfo
                  }
                  
                  const passCondition = participateInfo.data.pass_condition || false;

                  if (!passCondition) {
                    this.bootNotAvailableToast();
                  }
                  this.canParticipate = passCondition;
              } catch (e) {
                  console.log('[checkParticipate] error: ', e);
                  this.canParticipate = false;
              }
          },
          async checkAwardsDetail() {
              try {
                const user_id = this.userProfile.user_id
                if (!user_id) {
                  throw new Error("user_id is empty")
                }

                const params = {
                  user_id,
                  award_aliases: [this.awardAliasPrimary, this.awardAliasSecondary].filter(i => i).join(','),
                  headers: { authorization: this.token }
                };
                const awardInfo = await this.getAwardCompAwardsDetail(params);

                if (awardInfo) {
                  this.isParticipate = awardInfo.data.is_participate || false;
                }
              } catch (e) {
                console.log("[checkAwardDetail] error: ", e)
                this.isParticipate = false
              }
          },
          async buttonClick() {
              // 获取位置信息（放在最前，因为获取完位置后状态会变化）
              if (
                  !this.disableLocate &&
                  this.buttonStatus === awardButtonStatus.PENDING
              ) {
                  if (this.$refs.awardLocation) {
                      await this.$refs.awardLocation.getLocation();
                  }
              }

              // 更新登录状态
              await this.checkUser(); // #1 登录信息
              await this.getUserProfile(); // #2 用户信息 依赖#1

              // 点击流程
              const { locationStatus, issueStatus, buttonStatus } = this;

              if (buttonStatus === awardButtonStatus.REJECTED) {
                  if (issueStatus === awardIssueStatus.REJECTED) {
                      this.handleClick(awardClickTypeEnum.toastError);
                  }
                  return;
              }
              if (buttonStatus === awardButtonStatus.FULFILLED) {
                  this.handleClick(awardClickTypeEnum.jumpToAward);
                  return;
              }

              if (locationStatus === awardLocationStatus.UNINITIALIZED) {
                  this.$message('未初始化当前位置信息，请重试');
                  return 
              }

              if (!this.isLogin) {
                this.handleClick(awardClickTypeEnum.jumpToLogin);
                return
              }

              this.handleClick(awardClickTypeEnum.receiveAwards);
          },
          handleClick(type, target) {
              const { appHomePage } = this.awardCompConfig || {};

              switch (type) {
                  case awardClickTypeEnum.jumpToAward:
                      this.trackClick({
                          click_url: this.awardPageLink,
                          button_name: '查看奖励'
                      });
                      this.jumpTo(this.awardPageLink);
                      break;
                  case awardClickTypeEnum.jumpToAppHome:
                      this.trackClick({
                          click_url: appHomePage,
                          button_name: '打开APP'
                      });
                      this.jumpTo(appHomePage);
                      break;
                  case awardClickTypeEnum.toHash:
                      // 先获取页面配置
                      this.checkConfig().then(() => {
                          this.trackClick({
                              click_url: target
                          });
                          this.jumpTo(target);
                      });
                      break;
                  case awardClickTypeEnum.jumpToLogin:
                      this.trackClick({
                          click_url: isInNioCNApp() ? NIO_SCHEMA.LOGIN : 'h5 login common page',
                          button_name: '打卡领奖'
                      });
                      this.checkUser(true, {
                        inviterChannel: this.channelCode,
                        campaignCode: this.pageConfig.campaignSourceCode,
                      });
                      break;
                  case awardClickTypeEnum.receiveAwards:
                      this.trackClick({ button_name: '打卡领奖' });
                      this.issueAwards();
                      break;
                  case awardClickTypeEnum.toastError:
                      this.bootNotAvailableToast();
                  default:
                      break;
              }
          },
          jumpTo(href) {
              if (!href) {
                  return;
              }

              if (!href.startsWith('http') && isWx()) {
                  pushHash(
                      encodeURIComponent(
                          JSON.stringify({
                              jump: 'immediate',
                              index: this.index,
                              from: this.rootMark,
                              target: href || ''
                          })
                      )
                  );
                  this.isShowMask = true;
                  return;
              }

              if (!href.startsWith('http') && isInNioCNApp()) {
                  redirectToViewBridge(href);
              } else {
                  location.href = href;
                  if (!href.startsWith('http') && !isInNioCNApp()) {
                      const { downloadMiddlePage } = this.awardCompConfig || {};

                      setTimeout(() => {
                          if (downloadMiddlePage) {
                              window.location.href = downloadMiddlePage;
                          }
                      }, 3000);
                  }
              }
          },
          async issueAwards() {
              try {
                  this.isLoading = true;
                  //   埋点 begin
                  this.trackRetentionFlow({ step_name: 'begin' });

                  // 发奖
                  const issueResult = await this.awardCompReceiveAwards({
                      id: this.lpConfig.lpId,
                      token: this.lpConfig.lpToken,
                      headers: { authorization: this.token },
                      campaign_code: this.pageConfig.campaignSourceCode,
                      fellow_id: this.campaignOption.fellowId,
                      fellow_emp_domain: this.campaignOption.fellowEmpDomain
                  });
                  if (issueResult.result_code !== 'success') {
                      throw issueResult;
                  }

                  const { name = '打卡奖励', pic_url = '' } = issueResult.data;
                  this.receiveAwardsDlgSetting = {
                      title: '领取成功',
                      btnText: '查看奖励',
                      desc: `恭喜获得${name}，下载蔚来App后在：朋友-通知-消息-${name}中查看`,
                      img: pic_url
                  };

                  // 刷新奖励领取情况
                  await this.checkAwardsDetail();
                  this.isShowReceiveAwardsDialog = true;
              } catch (e) {
                  console.log(e);
                  this.$message('奖励领取失败，请稍后重试');
              } finally {
                  this.isLoading = false;
              }
          },
          async trackClick(payload) {
              const isClickable =
                  this.buttonStatus !== awardButtonStatus.REJECTED;

              if (this.trackSelectAction) {
                  await this.trackSelectAction({
                      is_clickable: isClickable,
                      is_accept: this.isParticipate,
                      distance: this.userPosition.distance,
                      ...payload
                  });
              }
          },
          bootNotAvailableToast(msg = this.notAvailableTip) {
              this.$message(msg || '当前用户无法参与活动');
          },
          handleImageError(e) {
              e.target.src = '';
          },
          handleCloseDialog() {
              this.isShowReceiveAwardsDialog = false;
          },
          trackRetentionFlow(custom = {}) {
              this.$tracker.collectPlus('RetentionFlow', {
                  requirement_id: 540,
                  track_sign: 'aCar.b1013.c1799.d1809.result.RetentionFlow',
                  lp_id: this.lpConfig.lpId,
                  campaign_code: this.pageConfig.campaignSourceCode,
                  invite_account: this.campaignOption.accountId,
                  car_model: this.pageConfig.presetModel.toUpperCase(),
                  city: this.userPosition.cityName, // @TODO: app定位和wx定位没有
                  page: PAGE_MODE_MAP[this.formMode],
                  link: window.location.href,
                  component_id: this.componentId,
                  mkt_type: this.trackName,
                  position_rank: this.positionRank,
                  is_clickable: true,
                  ...custom
              });
          }
      }
  };
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-award {
    width: 100%;
    background-color: #fff;
    position: relative;

    .loading-mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.35);
        z-index: 10;
    }

    .loading {
        height: 30 * @layout375;
        width: 30 * @layout375;
        border-width: 3 * @layout375;
        border-style: solid;
        border-radius: 50%;
        border-color: rgba(255, 255, 255, 0.8) rgba(58, 60, 68, 0.5)
            rgba(58, 60, 68, 0.5);
        animation: rotate-right 1s linear infinite normal;
    }

    .receive-awards-dialog {
        .nio-dialog__header {
            margin-bottom: 20 * @layout375;
        }
        &-img {
            width: 80 * @layout375;
            display: block;
            margin: auto;
            margin-bottom: 20 * @layout375;
        }
        &-desc {
            font-size: 16 * @layout375;
            line-height: 24 * @layout375;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/award/award.vue